import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.scss';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [programsDropdownOpen, setProgramsDropdownOpen] = useState(false);
  const [presentationDropdownOpen, setPresentationDropdownOpen] = useState(false);
  const location = useLocation();
  const dropdownTimeoutRef = React.useRef(null);
  const presentationDropdownTimeoutRef = React.useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const isMobile = window.innerWidth <= 968;
      setScrolled(isMobile || window.scrollY > 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setProgramsDropdownOpen(false);
    setPresentationDropdownOpen(false);
  }, [location]);

  const handleDropdownEnter = () => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    setProgramsDropdownOpen(true);
  };

  const handleDropdownLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setProgramsDropdownOpen(false);
    }, 300);
  };

  const handlePresentationDropdownEnter = () => {
    if (presentationDropdownTimeoutRef.current) {
      clearTimeout(presentationDropdownTimeoutRef.current);
    }
    setPresentationDropdownOpen(true);
  };

  const handlePresentationDropdownLeave = () => {
    presentationDropdownTimeoutRef.current = setTimeout(() => {
      setPresentationDropdownOpen(false);
    }, 300);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img 
              src="/assets/IMG/logo_transparent.png" 
              alt="BE TALENTED Logo" 
              className="logo"
            />
          </Link>
        </div>

        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link nav-link-home">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </Link>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={handlePresentationDropdownEnter}
            onMouseLeave={handlePresentationDropdownLeave}
          >
            <Link to="/presentation" className="nav-link">
              Présentation
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                <path d="M2 4 L6 8 L10 4"/>
              </svg>
            </Link>
            {presentationDropdownOpen && (
              <div className="dropdown-menu" onMouseEnter={handlePresentationDropdownEnter} onMouseLeave={handlePresentationDropdownLeave}>
                <Link to="/presentation" className="dropdown-item">Présentation</Link>
                <Link to="/beneficiaires" className="dropdown-item">Bénéficiaires</Link>
              </div>
            )}
          </div>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={handleDropdownEnter}
            onMouseLeave={handleDropdownLeave}
          >
            <Link to="/programmes" className="nav-link">
              Programmes
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                <path d="M2 4 L6 8 L10 4"/>
              </svg>
            </Link>
            {programsDropdownOpen && (
              <div className="dropdown-menu" onMouseEnter={handleDropdownEnter} onMouseLeave={handleDropdownLeave}>
                <Link to="/programmes" className="dropdown-item">Liste des programmes</Link>
                <Link to="/programmes/code" className="dropdown-item">CODE</Link>
                <Link to="/programmes/trajectoire" className="dropdown-item">TRAJECTOIRE</Link>
                <Link to="/programmes/propel" className="dropdown-item">PROPEL</Link>
              </div>
            )}
          </div>
          <Link to="/partenaires" className="nav-link">Partenaires</Link>
          <Link to="/actualites" className="nav-link">Actualités</Link>
          <Link to="/contact" className="nav-link">Contact</Link>

          <div className="mobile-actions">
            <Link to="/faire-un-don" className="btn-donate">Faire un don</Link>
            <Link to="/inscription" className="btn-outline">S'inscrire</Link>
            <Link to="/connexion" className="btn-primary">Se Connecter</Link>
          </div>
        </div>

        <div className="navbar-actions">
          <Link to="/faire-un-don" className="btn-donate">Faire un don</Link>
          <Link to="/inscription" className="btn-outline">S'inscrire</Link>
          <Link to="/connexion" className="btn-primary">Se Connecter</Link>
        </div>

        <button 
          className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
